import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { LiveCode } from "../components/code";
export const _frontmatter = {
  "title": "Navigation"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Navigation`}</h1>
    <p>{`Examples of combining `}<inlineCode parentName="p">{`@theme-ui/components`}</inlineCode>{` to create and style navigation structures.`}</p>
    <hr></hr>
    <h2>{`Menu Bar`}</h2>
    <p>{`A typical menu navigation you'd see on the top of a site`}</p>
    <LiveCode mdxType="LiveCode">
  {`<Flex as="nav" sx={{justifyContent: 'space-between'}}>
  <Flex sx={{ alignItems: 'center' }}>
    <div>
      <NavLink href="#!" sx={{ p: '2', display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: '2'}}>
        <Logo sx={{ minWidth: 40 }}/> Gallery
      </NavLink>
    </div>
    <NavLink href="#!" p={2}>
      Docs
    </NavLink>
    <NavLink href="#!" p={2}>
      Blog
    </NavLink>
  </Flex>
  <Box sx={{ display: 'flex', placeItems: 'center' }}>
    <Button py={1}>Get Started</Button>
  </Box>
</Flex>`}
    </LiveCode>
    <h2>{`Horizontal Navigation`}</h2>
    <p>{`Navigation style menus that run left to right, generally in the header or nav at the top of a page.`}</p>
    <h3>{`Simple`}</h3>
    <p>{`Horizontal list displayed from left to right.`}</p>
    <LiveCode containerSx={`sx={{width: '50%'}}`} mdxType="LiveCode">
  {`<Flex as="nav">
  <NavLink href="#!" p={2}>
    Home
  </NavLink>
  <NavLink href="#!" p={2}>
    Blog
  </NavLink>
  <NavLink href="#!" p={2}>
    About
  </NavLink>
</Flex>`}
    </LiveCode>
    <h3>{`Contained Link Group`}</h3>
    <p>{`A link group wrapped by a border.`}</p>
    <LiveCode mdxType="LiveCode">
  {`<Flex as="nav" sx={{ width: '100%' }}>
  <NavLink href="#!" sx={{ border: '1px solid', borderColor: 'border', textAlign: 'center', borderTopRightRadius: '0', borderBottomRightRadius: '0' }}>
    Account
  </NavLink>
  <NavLink href="#!" sx={{ border: '1px solid', borderColor: 'border', textAlign: 'center', borderRadius: '0' }}>
    Notifications
  </NavLink>
  <NavLink href="#!" sx={{ border: '1px solid', borderColor: 'border', textAlign: 'center', borderTopLeftRadius: '0', borderBottomLeftRadius: '0' }}>
    Settings
  </NavLink>
</Flex>`}
    </LiveCode>
    <h3>{`Contained Full-rounded`}</h3>
    <p>{`Navigation links with a border and rounded edges displayed horizontally.`}</p>
    <LiveCode mdxType="LiveCode">
  {`<Flex as="nav" sx={{ width: '100%' }}>
  <NavLink href="#!" sx={{ border: '1px solid', borderColor: 'border', textAlign: 'center', borderRadius: 0,  borderTopLeftRadius: 50, borderBottomLeftRadius: 50  }}>
    Account
  </NavLink>
  <NavLink href="#!" sx={{ border: '1px solid', borderColor: 'border', textAlign: 'center', borderRadius: '0' }}>
    Notifications
  </NavLink>
  <NavLink href="#!" sx={{ border: '1px solid', borderColor: 'border', textAlign: 'center', borderRadius: 0, borderTopRightRadius: 50, borderBottomRightRadius: 50 }}>
    Settings
  </NavLink>
</Flex>`}
    </LiveCode>
    <h2>{`Vertical Navigation`}</h2>
    <p>{`Navigation style menus that run top to bottom, generally in a sidebar on a page.`}</p>
    <h3>{`Rounded Pills`}</h3>
    <p>{`Simple round pills stacked vertically.`}</p>
    <LiveCode mdxType="LiveCode">
  {`<Flex as="nav" sx={{ width: '50%', flexDirection: 'column' }}>
  <NavLink href="#!" sx={{ p: 2, borderRadius: '2'}}>
    Home
  </NavLink>
  <NavLink href="#!" sx={{ p: 2, borderRadius: '2'}}>
    Blog
  </NavLink>
  <NavLink href="#!" sx={{ p: 2, borderRadius: '2'}}>
    About
  </NavLink>
</Flex>`}
    </LiveCode>
    <h3>{`Pills with Active Right border`}</h3>
    <p>{`Active element styled as a right border to show location in the site.`}</p>
    <LiveCode mdxType="LiveCode">
  {`<Flex as="nav" sx={{ width: '50%', flexDirection: 'column', borderRight: '1px solid', borderColor: 'border' }}>
  <NavLink href="#!" sx={{ p: 2, borderRadius: '0', borderRight: '3px solid', borderColor: 'primary', color: 'primary' }}>
    Home
  </NavLink>
  <NavLink href="#!" sx={{ p: 2, borderRadius: '0'}}>
    Blog
  </NavLink>
  <NavLink href="#!" sx={{ p: 2, borderRadius: '0'}}>
    About
  </NavLink>
</Flex>`}
    </LiveCode>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      